var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"paiming"},[_vm._v(" 互联网+招标釆购 ")]),_c('div',{staticClass:"paiming2"},[_c('div',{staticClass:"ms"},[_vm._v(" 互联网+招标采购综合变了度评估结果显示,上海综合得分最高, 本市排名第2名,得分相差10 ")]),_c('div',{staticClass:"paiming2x"},[_c('hicschart',{staticClass:"high",attrs:{"id":"high"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }